import { Component, Input, computed, signal } from '@angular/core';
import {
  AppEnvironment,
  resolveEnvironment,
} from '../../shared/environment/app-environment';

/**
 * Small always-visible chip in the topbar showing which deployment the user is
 * on (PROD / QA / LOCAL), derived from the browser hostname. Environment codes
 * are technical identifiers shown identically in every language (like the EN/FR
 * language codes in the topbar), so they are intentionally not translated.
 * Unknown hosts show their hostname verbatim rather than a guessed label.
 */
@Component({
  selector: 'app-environment-badge',
  standalone: true,
  templateUrl: './environment-badge.html',
  styleUrl: './environment-badge.scss',
})
export class EnvironmentBadge {
  private readonly _hostname = signal(globalThis.location?.hostname ?? '');

  /** Override the detected hostname (primarily for tests). */
  @Input() set hostname(value: string) {
    this._hostname.set(value);
  }

  protected readonly env = computed<AppEnvironment>(() =>
    resolveEnvironment(this._hostname()),
  );

  protected readonly label = computed(() => {
    switch (this.env()) {
      case 'prod':
        return 'PROD';
      case 'qa':
        return 'QA';
      case 'local':
        return 'LOCAL';
      default:
        return this._hostname();
    }
  });
}
